<script>
import FormBlock from '@/components/FormBlock.vue';
import ChartBar2 from '@/components/chart/ChartBar2.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'UserDetailBarChartTile',
  components: { FormBlock, ChartBar2, BaseButton },
  props: {
    config: Object,
    data: Array,
    commonLabel: String,
  },
  computed: {
    chartId() {
      return this._id; // eslint-disable-line no-underscore-dangle
    },
  },
};
</script>

<template lang="pug">
FormBlock(mobile)
  .b-user-detail-bar-chart-tile
    ._header
      ._label {{ commonLabel }}
      slot
    ._bar
      ChartBar2(:data="data" :barConfig="config" :chartId="chartId")
</template>

<style scoped lang="scss">
.user-detail-bar-chart-tile {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 6px;
    border-bottom: 1px solid rgb(235, 239, 242);
  }

  &__label {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
  }

  &__bar {
    width: 100%;
    height: 200px;
    padding-top: 24px;
  }
}
</style>
